// Primitive components will be implemented here
// These components should work on both web and native

export const PRIMITIVES_VERSION = '0.1.0';

// Placeholder exports - implement cross-platform components here
// Example implementations would include:
// - Button
// - Input
// - Card
// - Modal
// - Text
// - View

// For now, export utility functions that work on both platforms
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}
